import { createAction, props } from '@ngrx/store';
import { IToteWageringGetCountersResponse, TError } from '@amwager/util-ts';



/**
 * State
 */
export const initTicketState = createAction(
  '[Ticket] Init State',
  props<{
    sourceInitiator: string
  }>()
);
export const clearTicketState = createAction(
  '[Ticket] Clear State',
  props<{
    sourceInitiator: string
  }>()
);

export const loadTicketStateSuccess = createAction(
  '[Ticket] Load Ticket State Success'
);
export const loadTicketStateFailure = createAction(
  '[Ticket] Load Ticket State Failure',
  props<{ error: TError }>()
);



/**
 * GET Request
 */
export const getCountersAPI = createAction(
  '[Ticket_API] Get counters',
  props<{
    runId: string,
    sourceInitiator: string
  }>()
);


/**
 * GET Response SUCCESS
 */
export const getCountersAPISuccess = createAction(
  '[Ticket_API] Successfully get counters',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ successResponse: IToteWageringGetCountersResponse }>()
);



/**
 * GET Response ERROR
 */
export const getCountersAPIFailed = createAction(
  '[Ticket_API] Failed to get counters',
  props<{ errorResponse: TError }>()
);


/**
 * Properties
 */
export const setError = createAction(
  '[Ticket] Set an error',
  props<{ error: TError }>()
);
